import { Pipe } from '@angular/core';

@Pipe({
    name: 'currencyReal'
})

export class CurrencyRealReplacerPipe {

	transform(value: any, fallback?: string): string {
        value = Number(value);
        const strValue: string = (value) ? value.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+\,)/g, "$1.") : '0,00';
		return 'R$ ' + strValue;
	}
}



// WEBPACK FOOTER //
// ./src/app/pipes/currency-real-replacer.pipe.ts